import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function I() {
    const { useLang, useEffect, useState, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar60w');
    const [winW, setWinW] = useState(1920);
    const IMG_SPECS_EU = ['eu', 'de', 'fr', 'it', 'es', 'kr'];

    const swiperLists: any = [
        {
            src: require(`@publicLocal/solar-60w/pc/9_1${IMG_SPECS_EU.includes(locale) ? '_eu' : locale === 'uk' ? '_uk' : ''}.jpg`),
        },
        {
            src: require(`@publicLocal/solar-60w/pc/9_2${IMG_SPECS_EU.includes(locale) ? '_eu' : locale === 'uk' ? '_uk' : ''}.jpg`),
        },
        {
            src: require('@publicLocal/solar-60w/pc/9_3.jpg'),
        },
    ];

    useEffect(() => {
        setWinW(window.innerWidth);
    }, []);

    useEffect(() => {
        const prevBtn = document.querySelector('.solar-60w-I .swiper .swiper-button-prev') as HTMLDivElement;
        const nextBtn = document.querySelector('.solar-60w-I .swiper .swiper-button-next') as HTMLDivElement;
        if (prevBtn && nextBtn) {
            prevBtn.style.left = `${(winW - 1120) / 2 + 1120 - 148}px`;
            nextBtn.style.right = `${(winW - 1120) / 2}px`;
        }
    }, [winW]);

    return (
        <div className={`solar-60w-I ${css['solar-60w-I']}`}>
            <div className="text-box">
                <p className="title">{t('sec9_title')}</p>
            </div>
            <div className="swiper-box">
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    navigation={true}
                    pagination={{
                        clickable: true,
                    }}
                    centeredSlides={true}
                    spaceBetween={40}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    loop={true}
                    preloadImages={false}
                    lazy={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                >
                    {swiperLists?.map((list: any, k: number) => (
                        <SwiperSlide className="swiper-item" key={k}>
                            <NextImage src={list?.src} alt={t('sec9_title')} aria-label={t('sec9_title')} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
